import { Icon, Typography, useTheme } from '@web-chat-core/ui-kit';
import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { PROCESSOR_TYPES } from 'features/VirtualBackground/types';
import { setSelectedProcessor } from 'features/VirtualBackground/hooks/useManageBackgroundProcessor';
import {
    selectAvailableProcessors,
    selectActiveProcessor,
} from 'features/VirtualBackground/state/selectors/virtualBackground';
import { VirtualBackgroundProcessorButton } from '../VirtualBackgroundProcessorButton/VirtualBackgroundProcessorButton';
import { VirtualBackgroundProcessorImageButton } from '../VirtualBackgroundProcessorButton/VirtualBackgroundProcessorImageButton';
import { VirtualBackgroundsContainer } from './view';

export const VirtualBackgroundsList = observer(() => {
    const theme = useTheme();
    const availableProcessors = selectAvailableProcessors();
    const activeProcessor = selectActiveProcessor();

    const handleClick = useCallback((key: string) => {
        setSelectedProcessor(key);
    }, []);

    return (
        <VirtualBackgroundsContainer>
            {[...availableProcessors.entries()].map(([key, processorInfo]) => {
                const isSelected = key === activeProcessor;
                const isImageProcessor = processorInfo.type === PROCESSOR_TYPES.image;
                const isBlurProcessor = processorInfo.type === PROCESSOR_TYPES.blur;

                if (isImageProcessor) {
                    return (
                        <VirtualBackgroundProcessorImageButton
                            key={key}
                            onClick={() => handleClick(key)}
                            imageSrc={processorInfo.previewSrc}
                            isSelected={isSelected}
                        />
                    );
                }

                return (
                    <VirtualBackgroundProcessorButton
                        key={key}
                        onClick={() => handleClick(key)}
                        isSelected={isSelected}
                    >
                        <Icon
                            icon={isBlurProcessor ? 'icBlur32' : 'icBlock32'}
                            color={theme.root.colors.basicColors['90%']}
                            size={24}
                        />
                        <Typography variant="caption4">{processorInfo.text}</Typography>
                    </VirtualBackgroundProcessorButton>
                );
            })}
        </VirtualBackgroundsContainer>
    );
});
